// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation PurchaseUpsLabelMutation($input: PurchaseUpsLabelInput!) {
    purchaseUpsLabel(input: $input) {
      error
      shipmentEdge {
        node {
          id
          trackingNumber
          carrierName
          shippingMethod
          shippingCost
          serviceType
          serviceName
          shippingLabelUrl
          upsShipmentId
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
